import { checkViewerPermission } from "services/utils/HelperFunction";
import { nodeHasAccess } from "services/utils/companyAccess";

export const hasTeamWorkspaceHomeAccess = (moduleDetails) => {
  if (!Array.isArray(moduleDetails)) return false;

  const home = moduleDetails.find((module) => module?.module_name === "Home");
  // has_access when the payload sends it, else any Home submodule viewer.
  return Boolean(home) && nodeHasAccess(home);
};

// Same "Rosters" module / "Roster" submodule pair homeDashboardAccess.js and
// PlanShift/index.js's own canManageShift already check — used here to gate
// the Team Workspace Rosters route itself (RosterAccessGate), not just the
// Home dashboard card and the in-page manage action. The sidebar already
// hides the Rosters row without this submodule's viewer permission
// (Sidebar/index.js's TEAM_WORKSPACE_VIEWER_GATED_MODULES), but hiding the
// nav link never stopped the route itself from still rendering PlanShift on
// a direct visit or a refresh while already on the page — Admin.js registers
// every route unconditionally, with no permission check of its own.
export const hasTeamWorkspaceRosterAccess = (moduleDetails) =>
  checkViewerPermission(moduleDetails, "Rosters", "Roster");
